<template>
  <div>
    <LibraryBanner title="Your Library">
      <template v-slot:breadcrumbList>
        <li class="active">Your Library: All Resources</li>
      </template>
    </LibraryBanner>
    <div class="container">
      <library-tabs active-tab="All Resources"/>
      <div
        id="all-resources-tab-panel"
        role="tabpanel"
        aria-labelledby="all-resources-tab">
        <div v-if="loading">
          <p class="gb-text-2 text-muted loading-spinner"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading resources...</p>
        </div>
        <template v-if="!loading">
          <div class="row" v-if="betaVisibility">
            <div class="col-sm-8">
              <ResourcesLibrary :resources="resources" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <present-levels-library context="Present Levels" :presentlevels="presentlevels"/>
            </div>
            <div class="col-md-4">
              <goals-library context="All Goals" :goals="goals"/>
            </div>
            <div class="col-md-4">
              <strategy-library context="All Strategies" :strategies="strategies"/>
            </div>
          </div>
        </template>
      </div>
      <SubmitFeedback type="Library" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SubmitFeedback from '@/components/SubmitFeedback'
import GoalsLibrary from '@/components/library/GoalsLibrary'
import StrategyLibrary from '@/components/library/StrategyLibrary'
import PresentLevelsLibrary from '@/components/library/PresentLevelsLibrary'
import ResourcesLibrary from '@/components/library/ResourcesLibrary'
import LibraryTabs from '@/components/library/LibraryTabs'
import LibraryBanner from '@/components/library/LibraryBanner'
import { getAllResourcesForContentTypes } from '@/api/library'
import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  name: 'AllResourcesPage',
  components: {
    SubmitFeedback,
    GoalsLibrary,
    StrategyLibrary,
    PresentLevelsLibrary,
    ResourcesLibrary,
    LibraryTabs,
    LibraryBanner
  },
  data: function() {
    return {
      goals: [],
      strategies: [],
      presentlevels: [],
      resources: [],
      loading: true
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user.user.uuid
    }),
    ...mapGetters('visibility', ['betaVisibility'])
  },
  methods: {
    getResources: function() {
      this.loading = true
      var contentTypes = [
        CONTENT_TYPES.SAVED_GOAL,
        CONTENT_TYPES.SAVED_STRATEGY,
        CONTENT_TYPES.SAVED_SUPER_PAGE,
        CONTENT_TYPES.PRESENTLEVEL,
        CONTENT_TYPES.RESOURCE
      ]
      getAllResourcesForContentTypes(this.userId, contentTypes).then(data => {
        this.loading = false
        data.content = data.content.filter(resource => {
          return !resource.content_body_error
        })
        this.strategies = data.content.filter(resource => {
          return resource.content_type === CONTENT_TYPES.SAVED_STRATEGY
        })
        this.goals = data.content.filter(resource => {
          return (
            resource.content_type === CONTENT_TYPES.SAVED_GOAL ||
            resource.content_type === CONTENT_TYPES.SAVED_SUPER_PAGE
          )
        })
        this.presentlevels = data.content.filter(resource => {
          return resource.content_type === CONTENT_TYPES.PRESENTLEVEL
        })
        this.resources = data.content.filter(resource => {
          return resource.content_type === CONTENT_TYPES.RESOURCE
        })
      })
    }
  },
  created: function() {
    this.getResources()
    this.$sendEvent('Viewed All Resources Page')
  },
  watch: {
    userId: function() {
      this.getResources()
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';
@import '~@/variables.less';

.jumbotron {
  background: @libraryColorBg;
  margin-bottom: 0;
}
.fa-spinner {
  font-size: 1em;
}
.header-folder {
  color: #d2c361;
}
.add-student-button {
  margin-top: 90px;
}
.offset-page-subheader {
  margin-left: 80px;
}
.loading-spinner {
  margin-top: 24px;
}
</style>
